declare global {
  interface Window {
    homeDashboard_AudioContext: any;
    homeDashboard_AudioBuffer: any;
  }
}

function getAudioContext(): AudioContext {
  if (!window.homeDashboard_AudioContext) {
    window.homeDashboard_AudioContext = new AudioContext();
  }
  return window.homeDashboard_AudioContext;
}

export async function getAudioSource(url: string, pitch = 0, volume = 1) {
  const context = getAudioContext();
  if (!window.homeDashboard_AudioBuffer) {
    window.homeDashboard_AudioBuffer = new Map();
  }

  let buffer = window.homeDashboard_AudioBuffer.get(url);

  if (!buffer) {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const arrayBuffer = await response.arrayBuffer();

    buffer = await context.decodeAudioData(arrayBuffer);
    window.homeDashboard_AudioBuffer.set(url, buffer);
  }

  const source = context.createBufferSource();
  source.buffer = buffer;
  source.detune.value = pitch;

  const gainNode = context.createGain();
  gainNode.gain.value = -1 + volume;
  if (process.env.NODE_ENV === 'development' && navigator.userAgent.includes('Linux x86_64')) {
    gainNode.gain.value = -0.6;
  }
  gainNode.connect(context.destination);

  source.connect(context.destination);
  source.connect(gainNode);

  return source;
}
